import { H6 } from "../../../../../AbstractElements";
import { InvoiceSixTable } from "../../../../../Data/Applications/ECommerce/ECommerce";

const InvoiceSixTableHeader = () => {
  return (
    <>
      {InvoiceSixTable.map((data, i) => (
        <td className="item" key={i}>
          <H6 className="p-2 mb-0">{data}</H6>
        </td>
      ))}
    </>
  );
};

export default InvoiceSixTableHeader;
